import React, { useEffect } from 'react';
import { sharedTableStyles } from '../../../../utils/tableStyles';
import { TableSkeleton } from '../../../../components/UI/Skeleton/Skeleton';
import RowActionMenu from '../../../../components/UI/RowActionMenu/RowActionMenu';
import TableCard from '../../../../components/UI/TableToolbar/TableCard';
import TableToolbar from '../../../../components/UI/TableToolbar/TableToolbar';
import { Modal } from 'react-bootstrap';
import _debounce from 'lodash/debounce';
import DataTable from 'react-data-table-component';

import EmptyData from '../../../../components/UI/EmptyData';

import { useIsLoggedInQuery } from '../../../../redux/apis/authApi';
import { useGetEmployeeDropDownQuery } from '../../../../redux/apis/employee';
import { useEditComplainMutation, useGetComplainsQuery } from '../../../../redux/apis/ComplainApi';

import ComplainFormModel from './ComplainFormModel';
import './ComplainTable.scss';

import {
  LB_HEADER,
  LB_ASSETS_TABLE_COLS,
  LB_EMPLOYEE_TABLE_COLS,
  LB_EMPLOYEE_TABLE_COLS_SORT
} from '../../../../utils/constant/labels';
import { notification } from '../../../../utils/notification';
// import { EMPLOYEE } from '../../../../utils/constant/routeURL';
import { TOAST_TYPE } from '../../../../utils/constant/errorMessage';
// import { PLACEHOLDER } from '../../../../utils/constant/placeHolders';
import { BT_BUTTON_LABELS } from '../../../../utils/constant/buttons';
import { COMPLAIN_STATUS, GLOBAL, ROLES } from '../../../../utils/constant/global';
import { formatDate, getStatusBadge, paginationRow, skipRow } from '../../../../utils/handler';

const { ADMIN, HR } = ROLES;
const {
  LB_TBL_COL_STATUS,
  LB_TBL_COL_ACTION,
  LB_TBL_COL_REASON,
  LB_TBL_COL_REQUEST_DATE,
  LB_TBL_COL_SUPPORT_RESPONSE_REASON
} = LB_EMPLOYEE_TABLE_COLS;

const {
  LB_COMPLAIN_REJECT,
  LB_COMPLAIN_APPROVE,
  LB_ASK_COMPLAIN_APPROVE,
  LB_ASK_COMPLAIN_REJECT,
  LB_ADD_COMPLAIN_REQUEST
} = LB_HEADER;

const { ASC, DESC } = GLOBAL;
const { ACCEPTED, REJECTED } = COMPLAIN_STATUS;
const { TOAST_SUCCESS, TOAST_ERROR } = TOAST_TYPE;
const { BTN_ACCEPT, BTN_REJECT, BTN_ADD_COMPLAIN } = BT_BUTTON_LABELS;
const { SR_EMPLOYEE_NAME } = LB_EMPLOYEE_TABLE_COLS_SORT;
const { LB_TBL_COL_EMPLOYEE_NAME } = LB_ASSETS_TABLE_COLS;

const complainTableStyles = {
  ...sharedTableStyles,
  headCells: {
    style: {
      ...sharedTableStyles.headCells.style,
      color: '#334155',
      fontWeight: 700
    }
  },
  rows: {
    ...sharedTableStyles.rows,
    style: {
      ...sharedTableStyles.rows.style,
      color: '#6b7280'
    }
  },
  cells: {
    style: {
      ...sharedTableStyles.cells.style,
      color: '#6b7280',
      fontWeight: 600
    }
  }
};

const ComplainTable = ({ state, setState }) => {
  const { data: isLogin } = useIsLoggedInQuery();
  const [editComplain] = useEditComplainMutation();

  const isAdminHr =
    isLogin?.data?.hrxRole?.roleName === ADMIN || isLogin?.data?.hrxRole?.roleName === HR;

  const { data: dropdownData, refetch: employeeDropDownQuery } = useGetEmployeeDropDownQuery(
    {
      skip: skipRow(state?.currentPageDropdown, state?.rowsPerPageDropdown),
      limit: state.rowsPerPageDropdown
    },
    { skip: !isAdminHr }
  );

  const complainQueryArgs = {
    search: state.search,
    skip: skipRow(state.currentPage, state.rowsPerPage),
    limit: state.rowsPerPage,
    sort: state.sortField,
    sortType: state.sortDirection ? DESC : ASC,
    userId: isAdminHr ? undefined : isLogin?.data?._id
  };

  const { data, isLoading } = useGetComplainsQuery(complainQueryArgs, {
    skip: !isLogin?.data?._id && !isAdminHr
  });

  useEffect(() => {
    if (!dropdownData?.data || !Array.isArray(dropdownData.data)) return;

    setState((prevState) => ({
      ...prevState,
      dropdownDataStore:
        prevState.currentPageDropdown === 1
          ? dropdownData.data
          : [...prevState.dropdownDataStore, ...dropdownData.data]
    }));
  }, [dropdownData, setState]);

  useEffect(() => {
    if (data?.isNext === undefined) return;
    setState((prevState) =>
      prevState.isNext === data.isNext ? prevState : { ...prevState, isNext: data.isNext }
    );
  }, [data?.isNext, setState]);

  let columnT = '';
  columnT = [
    ...(isLogin.data?.hrxRole?.roleName === ADMIN || isLogin?.data?.hrxRole?.roleName === HR
      ? [
          {
            name: LB_TBL_COL_EMPLOYEE_NAME,
            sortField: SR_EMPLOYEE_NAME,
            selector: () => {},
            sortable: true,
            cell: (row) => (
              <div>
                <span className="complain-name">{row?.user?.name || ''}</span>
              </div>
            )
          }
        ]
      : []),
    {
      name: LB_TBL_COL_REQUEST_DATE,
      selector: (row) => formatDate(row?.dateOfRequest, 'DD-MMM-YYYY hh:mm a'),
      sortable: false
    },
    {
      name: LB_TBL_COL_REASON,
      selector: (row) => row.requestReason || '-',
      sortable: false,
      cell: (row) => <div className="reason-cell">{row.requestReason || '-'}</div>
    },
    {
      name: LB_TBL_COL_SUPPORT_RESPONSE_REASON,
      selector: (row) => row.responseReason || '-',
      sortable: false,
      cell: (row) => <div className="reason-cell">{row.responseReason || '-'}</div>
    },
    {
      name: LB_TBL_COL_STATUS,
      selector: (row) => getStatusBadge(row, 'status'),
      sortable: false
    }
  ];

  if (isLogin.data?.hrxRole?.roleName === ADMIN || isLogin.data?.hrxRole?.roleName === HR) {
    columnT.push({
      name: LB_TBL_COL_ACTION,
      selector: () => {},
      sortable: false,
      cell: (row) => (
        <RowActionMenu
          actions={[
            {
              label: 'Accept',
              icon: 'icofont-check-circled',
              variant: 'success',
              hidden: row.status === ACCEPTED,
              onClick: () => {
                setState({ ...state, isEditModal: { status: true, id: row?._id } });
              }
            },
            {
              label: 'Reject',
              icon: 'icofont-close-circled',
              variant: 'danger',
              hidden: row?.status === REJECTED,
              onClick: () => {
                setState({ ...state, isDeleteModal: { status: true, id: row?._id } });
              }
            }
          ]}
        />
      )
    });
  }

  const handleChangePage = (page) => {
    setState({ ...state, currentPage: page });
  };

  const handleChangeRowsPerPage = (newRowsPerPage) => {
    setState({ ...state, rowsPerPage: newRowsPerPage, currentPage: 1 });
  };

  const debouncedOnSearchData = _debounce((searchValue) => {
    setState((prevState) => ({ ...prevState, search: searchValue, currentPage: 1 }));
  }, 300);

  const handleChangeSort = (sortField) => {
    setState({ ...state, sortDirection: !state.sortDirection, sortField: sortField.sortField });
  };

  const handleAccept = () => {
    if (!state.reason) {
      setState({ ...state, reasonError: 'Reason is required' });
      return;
    }
    if (state.reason.length > 500) {
      setState({ ...state, reasonError: 'Reason must be less than 500 characters' });
      return;
    }
    handleStatusChange(ACCEPTED, state?.isEditModal.id, state.reason);
  };

  const handleReject = () => {
    if (!state.responseReason) {
      setState({ ...state, responseReasonError: 'Reason is required' });
      return;
    }
    if (state.responseReason.length > 140) {
      setState({ ...state, responseReasonError: 'Reason must be less than 140 characters' });
      return;
    }
    handleStatusChange(REJECTED, state?.isDeleteModal.id, state.responseReason);
  };

  const handleEditComplainRequest = async (complainRequest, id) => {
    try {
      setState((prevState) => ({ ...prevState, loading: true }));
      const res = await editComplain({ data: complainRequest, id });
      if (res.data?.success) {
        setState((prevState) => ({
          ...prevState,
          modalHeader: { title: '', isEdit: false },
          isDeleteModal: { status: false, id: '' },
          isEditModal: { status: false, id: '' },
          isEditModalData: {},
          loading: false,
          responseReason: '',
          reason: ''
        }));
        notification(res?.data?.statusMessage, TOAST_SUCCESS);
      } else {
        setState((prevState) => ({
          ...prevState,
          modalHeader: { title: '', isEdit: false },
          isDeleteModal: { status: false, id: '' },
          isEditModal: { status: false, id: '' },
          isEditModalData: {},
          loading: false,
          responseReason: '',
          reason: ''
        }));
        notification(res?.data?.statusMessage, TOAST_ERROR);
      }
    } catch (error) {
      setState((prevState) => ({ ...prevState, loading: false }));
      notification(error.message, TOAST_ERROR);
    }
  };

  const handleStatusChange = (status, id, reason) => {
    handleEditComplainRequest(
      {
        status,
        responseReason: reason
      },
      id
    );
  };

  /* const clearState = () => {
    setState((prevState) => ({
      ...prevState,
      reason: '',
      reasonError: '',
      responseReason: '',
      responseReasonError: '',
      loading: false,
      modalHeader: {
        ...prevState.modalHeader,
        title: LB_ADD_COMPLAIN_REQUEST,
        isEdit: false
      },
      isEditModalData: {}
    }));
  }; */

  return (
    <div className="row clearfix g-3">
      <div className="col-sm-12">
        <TableCard>
          <TableToolbar
            onSearch={debouncedOnSearchData}
            actions={
              <button
                type="button"
                className="app-table-toolbar__add-btn"
                onClick={() => {
                  setState((prevState) => ({
                    ...prevState,
                    modalHeader: {
                      ...prevState.modalHeader,
                      title: LB_ADD_COMPLAIN_REQUEST,
                      isEdit: true
                    },
                    isEditModalData: {}
                  }));
                }}
              >
                <i className="icofont-plus-circle"></i>
                {BTN_ADD_COMPLAIN}
              </button>
            }
          />
          <div className="card-body">
            <div className="complain-table">
              <DataTable
                customStyles={complainTableStyles}
                title={'Complaints'}
                columns={columnT}
                data={data?.data || []}
                defaultSortField="title"
                pagination
                paginationServer
                onSort={handleChangeSort}
                sortField={state.sortField}
                sortDirection={state.sortDirection}
                paginationTotalRows={paginationRow(
                  // state.isNext,
                  data?.isNext,
                  state.rowsPerPage,
                  state.currentPage,
                  data?.data?.length
                )}
                paginationPerPage={state.rowsPerPage}
                paginationRowsPerPageOptions={[5, 10, 20, 30]}
                paginationComponentOptions={{
                  noRowsPerPage: false,
                  rangeSeparatorText: 'of',
                  selectAllRowsItem: state.isNext,
                  selectAllRowsItemText: 'All',
                  paginationButtonsDisabled: state.isNext
                }}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                selectableRows={false}
                noDataComponent={<EmptyData />}
                className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                highlightOnHover={true}
                progressPending={isLoading && !data?.data}
                progressComponent={<TableSkeleton columns={6} />}
              />
            </div>
          </div>
        </TableCard>
      </div>

      {state?.modalHeader?.isEdit && (
        <ComplainFormModel
          state={state}
          setState={setState}
          onEmployeeDropDownRefetch={employeeDropDownQuery}
        />
      )}

      <Modal
        centered
        show={state?.isEditModal?.status}
        onHide={() => {
          setState({
            ...state,
            reason: '',
            reasonError: '',
            isEditModal: { status: false, id: '' }
          });
        }}
      >
        <Modal.Header closeButton>
          <h5 className="modal-title fw-bold" id="dremovetaskLabel">
            {LB_COMPLAIN_APPROVE}
          </h5>
        </Modal.Header>
        <Modal.Body className="justify-content-center flex-column d-flex">
          <i className="icofont-simple-smile text-success display-2 text-center mt-2"></i>
          <p className="mt-4 fs-5 text-center">{LB_ASK_COMPLAIN_APPROVE}</p>
          <div className="mb-3">
            <textarea
              rows={4}
              maxLength={140}
              className={`form-control mb-3 ${state.reasonError && 'is-invalid'}`}
              placeholder="Enter reason"
              value={state.reason}
              onChange={(e) => setState({ ...state, reason: e.target.value, reasonError: '' })}
            />
            {state.reasonError && <div className="invalid-feedback">{state.reasonError}</div>}
          </div>

          <button className="btn btn-success text-white" onClick={handleAccept}>
            {BTN_ACCEPT}
          </button>
        </Modal.Body>
      </Modal>

      <Modal
        centered
        show={state?.isDeleteModal?.status}
        onHide={() => {
          setState({
            ...state,
            responseReason: '', // Clear the reason when closing the modal
            responseReasonError: '', // Clear any error
            isDeleteModal: { status: false, id: '' }
          });
        }}
      >
        <Modal.Header closeButton>
          <h5 className="modal-title fw-bold" id="leaverejectLabel">
            {LB_COMPLAIN_REJECT}
          </h5>
        </Modal.Header>
        <Modal.Body className="justify-content-center flex-column d-flex">
          <i className="icofont-sad text-danger display-2 text-center mt-2"></i>
          <p className="mt-4 fs-5 text-center">{LB_ASK_COMPLAIN_REJECT}</p>
          <div className="mb-3">
            <textarea
              rows={4}
              maxLength={140}
              className={`form-control mb-3 ${state.responseReasonError && 'is-invalid'}`}
              placeholder="Enter reason"
              value={state.responseReason}
              onChange={(e) =>
                setState({
                  ...state,
                  responseReason: e.target.value,
                  responseReasonError: '' // Reset the error when typing
                })
              }
            />
            {state.responseReasonError && (
              <div className="invalid-feedback">{state.responseReasonError}</div>
            )}
          </div>
          <button className="btn btn-danger text-white" onClick={handleReject}>
            {BTN_REJECT}
          </button>
        </Modal.Body>
      </Modal>
    </div>
  );
};
export default ComplainTable;
